import sendRequest from "./send-request";
const BASE_URL = process.env.REACT_APP_BASE_URL;

export async function index() {
  return sendRequest(`${BASE_URL}/themes`, "GET");
}

export async function create(data) {
  return sendRequest(`${BASE_URL}/themes`, "POST", data);
}

export async function update(id, data) {
  return sendRequest(`${BASE_URL}/themes/${id}`, "PUT", data);
}

export async function remove(id) {
  return sendRequest(`${BASE_URL}/themes/${id}`, "DELETE");
}
